import { oz } from '@weft/utils';
import { PromotionModelInputSchema } from '../promotion/promotion-model-input-schema';
import { NewLineItemPromotionSchema } from './new-line-item-promotion-schema';

export const LineItemPromotionInputSchema = oz.object(NewLineItemPromotionSchema.shape)
  .extend({
    promotionModel: PromotionModelInputSchema,
  })
  .partial()
  .openapi('LineItemPromotionInput');

export type LineItemPromotionInput = oz.infer<typeof LineItemPromotionInputSchema>;